import React from "react";
import { InformationCircleIcon } from "@heroicons/react/outline";
import { colors } from "../../propsType/Colors";
import { EyeIcon, EyeOffIcon } from "@heroicons/react/outline";
const InputGeneric = ({
  position,
  title,
  titleRequired,
  type,
  name,
  value,
  onChange,
  defaultData,
  handleBlur,
  placeholder,
  errorText,
  disable = false,
  llaveProps,
  maxValue,
  iconTop,
  textTopTips,
  maxProps,
  show,
  funtionShow,
  onKeyDown=null,
  min = null
}) => {
  return (
    <div 
    className={ name === "typeDoc" || name === "phone" ? "h-full" : "space-y-1 w-full relative flex justify-between flex-col h-full"} 
    key={llaveProps}
    >
      <div className="relative flex items-center gap-[3px]">
        <label htmlFor="password" className={`block text-[${colors.darkBlue}]`}>
          <p className="text-sm font-medium ">
            {" "}{title} {titleRequired && `(${titleRequired})`}{" "}
          </p>
        </label>
        {iconTop && (
          <>
            <div
              className={` button cursor-pointer !w-[14px]`}
              data-tooltip={textTopTips}
            >
              <InformationCircleIcon className=" button !w-[14px]  cursor-pointer  text-green " />
            </div>
          </>
        )}
      </div>

      <div className={ name === "typeDoc" || name === "phone" ? "mt-0 h-full relative" : "mt-1 h-full relative"}>
        <input
          pattern={ name === "typeDoc" ? "[A-Za-z0-9]" : "[0-9]{0,13}"} 
          disabled={disable}
          defaultValue={defaultData}
          onBlur={handleBlur}
          name={name}
          value={value}
          placeholder={placeholder}
          type={type}
          maxLength={maxValue || ""}
          onChange={onChange}
          max={maxProps}
          onKeyDown={onKeyDown}
          min = {min}
          
          className={`appearance-none block ${maxProps ? "h-auto" : "h-full "
            } w-full px-3 py-2 border ${name === "typeDoc" || name === "phone"
              ? "rounded-r-lg"
              : "rounded-md "
            } ${errorText ? "border-red-500" : "border-gray-300"
            }  shadow-sm placeholder-gray-400 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm`}
        />
        {(name === "cvc" || name === "pinCard" || name === "numberCard" || name === "code"|| name === "numberCardCredit" || name === "cvvCard"|| name === "numberCardCredicard" || name === "password" 
          || name === "newPass" || name === "newPassConfirm" || name === "password" || name === "confirmPassword") && (
          <>
            {show ? (
              <>
                <EyeOffIcon
                  onClick={funtionShow}
                  className="w-5 h-5 absolute top-[25%] right-[2%]"
                />
              </>
            ) : (
              <>
                <EyeIcon
                  onClick={funtionShow}
                  className="w-5 h-5 absolute top-[25%] right-[2%]"
                />
              </>
            )}
          </>
        )}
      </div>
    </div>
  );
};

export default InputGeneric;
